import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { logout } from "@mainaction";
// core components
import Header from "./header";
import Sidebar from "./sidebar";
import MainContainer from "./main";
import routes from "../routes";

const Admin = (props) => {
  var { isLoggedIn, session } = props;
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      props.logout(session);
      navigate("/auth/login");
    } else if (isLoggedIn && !session?.username) {
      navigate("/dashboard");
    }
  }, [isLoggedIn, session]);

  return (
    <>
      <Header routes={routes} />
      <div className="h-full">
        <div className="h-full lg:grid lg:grid-cols-12">
          <div className="py-2 px-4 bg-white hidden lg:block lg:col-span-3 xl:col-span-2">
            <Sidebar routes={routes} />
          </div>
          <main className="py-4 h-90% lg:col-span-9 xl:col-span-10 overflow-y-auto bg-content">
            <MainContainer routes={routes} />
          </main>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return { isLoggedIn: state.isLoggedIn, session: state.session };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ logout }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
